import SelectNoOptions from '@/assets/icons/select-no-options.svg';
import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiAutocompleteStyles = {
    styleOverrides: {
        popper: {
            bordewrRadius: '12px',
            top: '2px !important',
            '&.base-Popper-root': {
                bordewrRadius: '12px',
            },
            '&.popper--checkboxes-filter': {
                zIndex: '11111 !important',
                visibility: 'visible !important',
                display: 'block !important',
                opacity: '1 !important',
                top: '-100px !important',
            },
        },
        paper: {
            backgroundColor: Palette.white,
            padding: '16px 4px',
            boxShadow: Palette.boxShadow.elevation8,
            borderRadius: '12px',
            '& ul': {
                padding: 0,
            },
        },
        listbox: {
            borderRadius: 0,
            '& .MuiAutocomplete-option': {
                backgroundColor: Palette.white,
                borderRadius: '8px',
                marginBottom: '2px',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '20px',
                padding: '8px 16px',
                '&:hover': {
                    backgroundColor: Palette.yellow.yellow50,
                },
            },
        },
        noOptions: {
            margin: '0 12px',
            backgroundColor: Palette.yellow.yellow50,
            padding: '18px 16px 18px 52px',
            borderRadius: '8px',
            color: Palette.black,
            fontSize: '14px',
            lineHeight: '20px',
            backgroundImage: `url("${SelectNoOptions}")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '16px',
        },
    },
};
